import type { Theme } from '@mui/material';

export const styles = {
  contentWrapper: (theme: Theme) => ({
    px: 4,
    backgroundColor: theme.colors.neutral[50],
    width: '70%',
    overflowY: 'auto',
  }),
  divider: (theme: Theme) => ({
    borderColor: theme.colors.neutral[100],
    mb: 2,
  }),
  kpiButton: (theme: Theme, isSelected: boolean) => ({
    display: 'flex',
    justifyContent: 'space-between',
    height: '34px',
    backgroundColor: isSelected
      ? theme.colors.yellow[400]
      : theme.colors.neutral[200],
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: isSelected
        ? theme.colors.yellow[400]
        : theme.colors.neutral[200],
    },
  }),
  headerText: (theme: Theme) => ({
    color: theme.colors.neutral[500],
  }),
  indicatorText: (theme: Theme) => ({
    color: theme.colors.neutral[500],
    alignSelf: 'center',
  }),
  radio: (theme: Theme, isSelected: boolean) => ({
    flexShrink: 0,
    color: isSelected ? theme.colors.secondary[500] : theme.colors.neutral[200],
    '& .MuiSvgIcon-root': {
      fontSize: '20px',
    },
    '&.Mui-checked': {
      color: isSelected
        ? theme.colors.secondary[500]
        : theme.colors.primary[200],
    },
  }),

  trendIndicator: (theme: Theme, trend: number) => ({
    color:
      trend > 0
        ? theme.colors.success[600]
        : trend < 0
          ? theme.colors.error[600]
          : theme.colors.neutral[600],
  }),
  indicatorContainer: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
    backgroundColor: theme.colors.neutral[100],
    p: 0.5,
    borderRadius: 1,
  }),
  kpiLabel: {
    marginBottom: '0 !important',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  statementsContainer: (theme: Theme) => ({
    marginTop: theme.spacing(3),
  }),
  statementContainer: {
    overflow: 'hidden',
    paddingRight: '2rem',
  },
  statementLabel: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  tableHeader: (theme: Theme) => ({
    display: 'grid',
    gridTemplateColumns: '8fr 2fr 1fr',
    padding: theme.spacing(1, 2),
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    marginLeft: 0,
  }),

  tableRow: (theme: Theme, isSelected: boolean) => ({
    display: 'grid',
    gridTemplateColumns: '9fr 2fr 1fr',
    borderRadius: '8px',
    padding: theme.spacing(0.5, 2),
    marginBottom: theme.spacing(1),
    cursor: 'pointer',
    backgroundColor: isSelected
      ? theme.colors.secondary[50]
      : theme.colors.neutral[50],
  }),
  error: (theme: Theme) => ({
    color: theme.colors.error[600],
  }),
};
